import { HttpClient } from '@angular/common/http';
import type { Translation } from '@jsverse/transloco';
import { getBrowserLang, TranslocoLoader } from '@jsverse/transloco';
import { inject, Injectable } from '@angular/core';
import { AVAILABLE_LANGUAGES } from '@app/models/languages';
import { assetUrl } from '@app/single-spa/asset-url';

@Injectable()
export class TranslocoHttpLoader implements TranslocoLoader {
  private readonly http = inject(HttpClient);

  getTranslation(lang: string) {
    let locale;

    if (lang) {
      locale = lang;
    } else {
      locale = AVAILABLE_LANGUAGES.find(key => key.includes(getBrowserLang()));
    }

    const url = assetUrl(`langs/${locale}.json`);

    return this.http.get<Translation>(url);
  }
}
